import { projects } from "../../data/content";
import { Eyebrow, Reveal, ArrowLink } from "./motion";

export default function FeaturedWork() {
  return (
    <section className="border-t border-white/10 bg-ink py-24 lg:py-[140px]" aria-label="Featured work">
      <div className="flex flex-wrap items-end justify-between gap-8 px-6 lg:px-12">
        <div>
          <Eyebrow>Featured Work</Eyebrow>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tighter text-white sm:text-4xl lg:text-5xl">
            Hapo Electronics &amp; Hapo Media
          </h2>
        </div>
        <ArrowLink light to="/companies/hapo-electronics" testId="view-all-projects">
          View All Projects
        </ArrowLink>
      </div>

      <div
        className="no-scrollbar mt-14 flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 pb-4 lg:px-12"
        data-testid="featured-work-scroller"
      >
        {projects.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.05} className="min-w-[280px] snap-start sm:min-w-[360px] lg:min-w-[420px]">
            <figure className="group relative aspect-[4/5] overflow-hidden">
              <img
                src={p.image}
                alt={`${p.title} — placeholder project image`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 p-6 text-xs font-bold uppercase tracking-[0.2em] text-white">
                {p.title}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
